<template>
  <div class="-mx-4 flex flex-col gap-[28px] lg:mx-0">
    <div class="flex flex-col overflow-x-hidden">
      <div v-if="!titleDisabled" class="flex flex-col p-4">
        <div
          class="mb-2 font-roboto text-[20px] font-medium leading-[26px] text-[#1F1F1F]"
        >
          {{ rubricsTitle }}
        </div>
        <div class="text-[14px] font-semibold leading-[17px] text-[#808080]">
          {{ active + 1 }} {{ typeLabel }} из {{ count }}
        </div>
      </div>
      <div class="custom-scrollbar-red overflow-y-auto overflow-x-hidden">
        <MainPageCardsReworkedPlayListPreview
          v-for="(item, index) in data"
          :key="item.id"
          :data="item"
          :category-title="categoryTitle"
          class="px-4 py-2 hover:bg-[#DC80871F] lg:px-3"
          :class="{ 'bg-[#DC80871F]': active === index }"
          @click="emit('changeActive', item.slug)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  titleDisabled: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Array,
    default: () => [],
  },
  count: {
    type: Number,
    default: 1,
  },
  rubricsTitle: {
    type: String,
    default: '',
  },
  categoryTitle: {
    type: String,
    default: '',
  },
  active: {
    type: Number,
    default: 0,
  },
  isAudio: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['changeActive']);

const typeLabel = computed(() => {
  return props.isAudio ? 'аудио' : 'видео';
});
</script>
